import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardBody } from "reactstrap";
import classnames from "classnames";
import GeneralValidationTab from "pages/operations/validationTaskRequestDetails/GeneralValidationTab";

const useStyles = makeStyles({
  root: {
    width: "100%",
    marginTop: 30,
    display: "flex",
  },
  container: {
    borderRadius: 30,
    width: "100%",
    padding: 30,
  },
  tabs: {
    display: "flex",
    padding: "30px 0",
    fontSize: 13,
    fontWeight: 600,
    flexDirection: "column",
    marginRight: -4,
  },
  tab: {
    backgroundColor: "#E1E1E1",
    padding: 15,
    borderRadius: "10px 0 0 10px",
    marginBottom: 10,
    whiteSpace: "nowrap",

    "&:hover": {
      cursor: "pointer",
    },
  },
  active: {
    backgroundColor: "#FFFFFF!important",
  },
  cardBody: {
    padding: 0,
  },
});

const DataTabs = ({ task, tabs, setLoader, updateData }) => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(`${tabs[0].group}>${tabs[0]?.id}`);

  const onTabClick = useCallback(e => {
    const tab = e.target.dataset.tab;
    setActiveTab(tab);
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.tabs}>
        {tabs?.map(item => (
          <div
            key={`${item.group}>${item?.id}`}
            className={classnames(classes.tab, activeTab === `${item.group}>${item?.id}` && classes.active)}
            data-tab={`${item.group}>${item?.id}`}
            onClick={onTabClick}
          >
            {item.group}
          </div>
        ))}
      </div>
      <Card className={classes.container}>
        <CardBody className={classes.cardBody}>
          <GeneralValidationTab task={task} type={activeTab} setLoader={setLoader} update={updateData} />
        </CardBody>
      </Card>
    </div>
  );
};

export default DataTabs;
